import kyWithSentry from './helper/kyWithSentry';

import getChartsListURL, {
  IChartsListURLArgs,
} from 'url-constructors/getChartsListURL';
import { ICustomer } from 'redux/reducers/customers';
import { IChartData } from 'redux/reducers/charts';

export interface ICustomerWithCharts extends ICustomer {
  charts: IChartData[];
}

const firstDspCharts = ['apple music', 'spotify'];
const firstOfficialCharts = ['billboard charts'];

const getChartsList = (options: IChartsListURLArgs): any =>
  kyWithSentry.get(getChartsListURL(options)).json();

const getCustomersWithcharts = (
  customers: ICustomer[],
  chartsList: IChartData[]
): ICustomerWithCharts[] => {
  return chartsList.reduce((prev: any[], current: IChartData) => {
    const findCustomerById = (customer: any): any =>
      customer.id === current.customerId;
    const addedCustomer = prev.find(findCustomerById);
    if (addedCustomer) {
      prev = prev.slice().map((customer: ICustomerWithCharts) =>
        customer.id === addedCustomer.id
          ? {
              ...customer,
              charts: [
                ...customer.charts,
                {
                  ...current,
                  displayName: `${current.chartDisplayName} ${current.updateFrequency}`,
                  name: `${current.chartDisplayName} ${current.updateFrequency}`,
                },
              ],
            }
          : customer
      );
    } else {
      prev.push({
        ...customers.find(findCustomerById),
        charts: [
          {
            ...current,
            displayName: `${current.chartDisplayName} ${current.updateFrequency}`,
            name: `${current.chartDisplayName} ${current.updateFrequency}`,
          },
        ],
      });
    }
    return prev;
  }, []);
};

const sortByPositionCount = (
  a: ICustomerWithCharts,
  b: ICustomerWithCharts
): number => b.charts.length - a.charts.length;

const sortByPositionCountOrNamePrecedence = (
  precedenceNames: string[]
): any => (a: ICustomerWithCharts, b: ICustomerWithCharts): number => {
  const idA = a.displayName.toLowerCase();
  const idB = b.displayName.toLowerCase();

  const indexA = precedenceNames.indexOf(idA);
  const indexB = precedenceNames.indexOf(idB);

  if (indexA > indexB) {
    return -1;
  }

  if (indexA < indexB) {
    return 1;
  }

  return sortByPositionCount(a, b);
};

const chartsInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData?: any
): Promise<Response> => {
  const { customers, chartPage } = interceptionData;

  const chartsListOptions = {
    chartType: chartPage,
    sortBy: 'id',
    sortOrder: 'desc',
    limit: 999,
    productType: 'track',
  };

  try {
    const { charts } = await getChartsList(
      chartsListOptions as IChartsListURLArgs
    );
    const customersAndCharts = getCustomersWithcharts(customers, charts).sort(
      sortByPositionCountOrNamePrecedence(
        chartPage === 'dsp' ? firstDspCharts : firstOfficialCharts
      )
    );

    return new Response(
      JSON.stringify({
        customersAndCharts,
      })
    );
  } catch (error) {
    return new Response(JSON.stringify({ reason: error.message }));
  }
};

export default chartsInterceptor;
